// Etichette italiane per i valori memorizzati nel database.
// Le chiavi sono i valori salvati e NON vanno mai modificate — qui si traduce
// soltanto ciò che l'utente vede a schermo.

export const roleLabels = {
    admin: "Amministratore",
    office: "Ufficio",
    operation: "Operazioni",
    maintenance: "Manutenzione",
    cleaner: "Pulizie",
};

export const departmentLabels = {
    office: "Ufficio",
    operation: "Operazioni",
    maintenance: "Manutenzione",
    cleaner: "Pulizie",
};

export const priorityLabels = {
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    "very urgent": "Urgentissima",
};

export const taskStatusLabels = {
    pending: "In attesa",
    completed: "Completata",
};

export const cityTaxStatusLabels = {
    pending: "In attesa",
    paid: "Pagata",
    exempted: "Esente",
};

export const paymentMethodLabels = {
    stripe: "Stripe",
    cash: "Contanti",
    pos: "POS",
    bank_transfer: "Bonifico Bancario",
    sumup: "SumUp",
};

export const reservationStatusLabels = {
    "checked-in": "Check-in effettuato",
    pending: "In attesa",
    cancelled: "Annullata",
    confirmed: "Confermata",
};

export const notificationStatusLabels = {
    sent: "Inviata",
    failed: "Fallita",
    pending: "In attesa",
    delivered: "Consegnata",
    read: "Letta",
};

export const notificationGroupLabels = {
    "City Tax": "Tassa di Soggiorno",
    "Arrival": "Arrivi",
    "Arrivals": "Arrivi",
    "Documents": "Documenti",
};

export const supportChatStatusLabels = {
    waiting: "In attesa",
    active: "Attiva",
    closed: "Chiusa",
};

export const genderLabels = {
    Male: "Maschio",
    Female: "Femmina",
    Other: "Altro",
};

export const docTypeLabels = {
    identity_card: "Carta d'Identità",
    passport: "Passaporto",
    driving_license: "Patente di Guida",
    interior_ministry_card: "Tessera Ministero dell'Interno",
};

export const noteTypeLabels = {
    note: "Nota",
    instruction: "Istruzione",
};

// Converte una mappa etichette in opzioni [etichetta, valore] per FormGenerate.
export const toOptions = (labels) => Object.entries(labels).map(([value, label]) => [label, value]);

// Etichetta per un valore salvato, con fallback sul valore stesso.
export const labelFor = (labels, value) => (value && labels[value]) || value;

// I tipi di notifica sono valori salvati nel database (es. "cron_city_tax_72h"):
// qui vengono solo resi leggibili in italiano.
const notificationTypeFixed = {
    whatsapp_city_tax_payment: "Pagamento tassa di soggiorno (WhatsApp)",
    ota_city_tax_payment: "Pagamento tassa di soggiorno (OTA)",
    whatsapp_arrival_reminder: "Promemoria arrivo (WhatsApp)",
    ota_arrival_reminder: "Promemoria arrivo (OTA)",
};

const notificationTypeSubjects = {
    city_tax: "Tassa di soggiorno",
    arrival: "Arrivo",
    document: "Documenti",
};

export const notificationTypeLabel = (type) => {
    if (!type) return type;
    if (notificationTypeFixed[type]) return notificationTypeFixed[type];
    const cron = type.match(/^cron_(.+)_(\d+)h$/);
    if (cron && notificationTypeSubjects[cron[1]]) {
        return `${notificationTypeSubjects[cron[1]]} — promemoria ${cron[2]}h`;
    }
    return type.replace(/_/g, " ");
};

export const userStatusLabels = {
    active: "Attivo",
    deactive: "Disattivato",
    inactive: "Disattivato",
};

// Etichette per le celle di SimpleDataTable, in base alla colonna.
// Il valore grezzo resta quello del database: serve ancora a costruire la
// classe CSS che colora la cella, quindi qui si traduce solo il testo.
const columnValueLabels = {
    role: roleLabels,
    status: userStatusLabels,
    department: departmentLabels,
    priority: priorityLabels,
};

export const columnValueLabel = (columnId, value) => {
    const map = columnValueLabels[columnId];
    if (!map || typeof value !== "string") return value;
    return labelFor(map, value);
};
